var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"btn-goto",style:({background:'url('+_vm.backgroundImg+') no-repeat',backgroundSize:'100% 100%'})},[_c('div',{staticClass:"btn",on:{"click":function($event){return _vm.h5Click()}}},[_vm._v("前往小程序")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }